import { render, staticRenderFns } from "./AccordionGroup.vue?vue&type=template&id=34597451&scoped=true&"
import script from "./AccordionGroup.vue?vue&type=script&lang=js&"
export * from "./AccordionGroup.vue?vue&type=script&lang=js&"
import style0 from "./AccordionGroup.vue?vue&type=style&index=0&id=34597451&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34597451",
  null
  
)

export default component.exports